import { adjustActionCardForPrompt } from '../../utils/ai/adjustActionCardForPrompt'
import { getSectionsToBeAnswered } from '../../utils/ai/getSectionsToBeAnswered'
import type { GeneratedPlayResponse, BackendClient } from '@playbooks/core/src/services/BackendClient'

interface GenerateResponsesOptions {
  playbooksBackendClient: BackendClient
  prompt: string
  actionCardsData: any
}

/**
 * Generate Action Card responses using LLM and the provided prompt.
 */
export default async function generateResponses({
  playbooksBackendClient,
  prompt,
  actionCardsData,
}: GenerateResponsesOptions): Promise<GeneratedPlayResponse[]> {
  // Generate text with the AI model
  return await playbooksBackendClient.generatePlayResponses({
    prompt,
    actionCard: JSON.stringify({ sections: getSectionsToBeAnswered(actionCardsData, true) }),
    knowledge: JSON.stringify(adjustActionCardForPrompt(actionCardsData.sections)),
  })
}
